module.exports = __webpack_public_path__ + "img/more.5a0455f5.svg";